var formatter = null

function getFormatter () {
  return formatter === null ? new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }) : formatter
}

export function formatCurrency (value) {
  return getFormatter().format(value)
}

export function setCurrency (value) {
  formatter = new Intl.NumberFormat('en-US', { style: 'currency', currency: value })
}
